import React, { Component } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import { userActions } from "../../_actions";
import { userConstants } from "../../_constants";
import "../../assets/css/generalInfo.css";
import footerDark from "../../assets/images/footer-dark.png";
import footer from "../../assets/images/footer.png";
import hospitalInfoDark from "../../assets/images/hospitalInfo-dark.png";
import hospitalInfo from "../../assets/images/hospitalInfo.png";
import loadingGif from "../../assets/images/loading.gif";
import phoneDark from "../../assets/images/phone-dark.png";
import phone from "../../assets/images/phone.png";
Modal.setAppElement("#root");

class GeneralInfo_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      hospital: {},
      hospital_description: "",
      hospital_tels: [""],
      tels: [],
      currentEvent: 0,
      BtnList: [
        {
          img: hospitalInfo,
          text: "اطلاعات کلی",
        },
        {
          img: phoneDark,
          text: "تلفن ها",
        },
        {
          img: footerDark,
          text: "مدیریت لینک فوتر",
        },
      ],
      addLinksModal: false,
      internalLinks: [],
      externalLinks: [],
      link: "",
      name: "",
      link_type: "",
    };
    this.globalStorage = this.props.globalStorage;
    this.hospital_id = JSON.parse(localStorage.getItem("hospital_id"));
  }

  componentDidMount = () => {
    this.getHospitals();
    this.getPhones();
    this.getLinks();
  };

  componentDidUpdate = (props, state) => {
    const { currentEvent } = this.state;
    if (state.currentEvent !== currentEvent) {
      this.setState({
        BtnList: [
          {
            img: currentEvent === 0 ? hospitalInfo : hospitalInfoDark,
            text: "اطلاعات کلی",
          },
          {
            img: currentEvent === 1 ? phone : phoneDark,
            text: "تلفن ها",
          },
          {
            img: currentEvent === 2 ? footer : footerDark,
            text: "مدیریت لینک فوتر",
          },
        ],
      });
      // this.getAnnouncements();
    }
  };

  getHospitals = () => {
    const { hospital_id } = this;
    this.props
      .dispatch(userActions.API("get", `v1/hospitals`, null, true))
      .then((res) => {
        this.setState({
          hospital: res.data.find((hospital) => hospital.id === hospital_id),
        });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getPhones = () => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `v1/sub_admin/hospital/phones`,
          null,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        this.setState({
          tels: res.data.filter(
            (phone) =>
              phone.phone_type === "external" && phone.operator === "main"
          ),
          hospital_tels:
            res.data.length === 0
              ? [""]
              : res.data
                  .filter(
                    (phone) =>
                      phone.phone_type === "external" &&
                      phone.operator === "main"
                  )
                  .map((phone) => phone.number),
        });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  putPhones = () => {
    const { hospital_tels, tels } = this.state;

    tels.map(({ id }, i) => {
      this.props
        .dispatch(
          userActions.API(
            "delete",
            `v1/sub_admin/hospital/phones/${id}`,
            null,
            true,
            false,
            JSON.parse(localStorage.getItem("tokenAdmin"))
          )
        )
        .then((res) => {
          if (tels.length - 1 === i) {
            hospital_tels.map((tel, index) => {
              if (tel === "") return;

              const data = {
                title: "شماره تماس ها",
                number: tel,
                phone_type: "external",
                operator: "main",
              };

              this.props
                .dispatch(
                  userActions.API(
                    "post",
                    `v1/sub_admin/hospital/phones`,
                    data,
                    true,
                    false,
                    JSON.parse(localStorage.getItem("tokenAdmin"))
                  )
                )
                .then((res) => {
                  if (hospital_tels.length - 1 === index) {
                    this.getPhones();
                  }
                })
                .catch(() =>
                  userActions.failure(userConstants.ERRORS["serverError"])
                );
            });
          }
          // getPhones();
        })
        .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
      // this.deletePhones(id)
    });
  };

  deletePhones = (id) => {
    const { getPhones } = this;

    this.props
      .dispatch(
        userActions.API(
          "delete",
          `v1/sub_admin/hospital/phones/${id}`,
          null,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        // getPhones();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getLinks = () => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `v1/sub_admin/hospital/links`,
          null,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        this.setState({
          externalLinks: res.data.filter(
            (link) => link.link_type === "external"
          ),
          internalLinks: res.data.filter(
            (link) => link.link_type === "interval"
          ),
        });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  postLinks = () => {
    const { getLinks, reset } = this;
    const { name, link, link_type } = this.state;

    const data = {
      title: name,
      url: link,
      link_type,
    };

    this.props
      .dispatch(
        userActions.API(
          "post",
          `v1/sub_admin/hospital/links`,
          data,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        getLinks();
        reset();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  // put   v1/sub_admin/hospital/links
  // { id, title , url , link_type ( interval , external )  }

  deleteLinks = (id) => {
    const { getLinks } = this;

    this.props
      .dispatch(
        userActions.API(
          "delete",
          `v1/sub_admin/hospital/links/${id}`,
          null,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        getLinks();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  putDescription = () => {
    const { config } = this;
    const { hospital_description } = this.state;

    const data = {
      description: hospital_description,
    };

    this.props
      .dispatch(
        userActions.API(
          "put",
          `v1/sub_admin/hospital`,
          data,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        userActions.successAlert(
          "با موفقیت به روز شد",
          "اطلاعات بیمارستان با موفقیت به روزرسانی شد",
          "متوجه شدم"
        );
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  handleTels = (telIndex, val) => {
    const { hospital_tels } = this.state;
    const arr = [...hospital_tels];
    arr[telIndex] = val;
    this.setState({ hospital_tels: arr.filter((item) => item !== null) });
  };

  reset = () => {
    this.setState({
      addLinksModal: false,
      link: "",
      name: "",
      link_type: "",
    });
  };

  handleDelete = (id) => {
    this.props
      .dispatch(userActions.question("حذف", "آیا از حذف مطمئن هستید؟"))
      .then((r) => {
        if (r.value) {
          this.deleteLinks(id);
        }
      });
  };

  render() {
    const {
      dispatch,
      handleTels,
      putDescription,
      putPhones,
      reset,
      postLinks,
      handleDelete,
    } = this;
    const {
      isLoading,
      hospital,
      hospital_description,
      hospital_tels,
      BtnList,
      currentEvent,
      addLinksModal,
      internalLinks,
      externalLinks,
      link,
      name,
    } = this.state;
    return (
      <div className="container-fluid px-5 pb-5 mt-3 generalInfo">
        <div className="row my-1">
          <Navigation
            onClick={(i) => this.setState({ currentEvent: i })}
            BtnList={BtnList}
          />
        </div>
        {currentEvent === 0 && (
          <div className="row mb-3">
            {hospital.name ? (
              <div className="col-lg-12 col-md-12 m-auto d-flex flex-column align-items-center">
                <div className="" style={{ padding: 0 }}>
                  <a href="#" className="card card__hospital">
                    <img
                      src={`${userConstants.SERVER_URL}${hospital.logo.url}`}
                      alt="hospital logo"
                      //   className="hospital_logo"
                      className="card__img"
                    />
                    <span className="card__footer">
                      <span>{hospital.name}</span>
                    </span>
                  </a>
                </div>
                <div className="col-lg-10">
                  <div>
                    <p
                      className=" text-right w-100 position-relative"
                      style={{
                        padding: "0 20px ",
                        outline: "none",
                        color: "#535353",
                        fontSize: "15px",
                      }}
                    >
                      توضیحات درباره بیمارستان
                    </p>
                    {hospital_description &&
                    hospital_description.length !== 0 ? (
                      <BtnRound
                        className={`save-icon submit-general-info`}
                        onClick={putDescription}
                      />
                    ) : (
                      ""
                    )}
                    <Textarea
                      placeholder="متن توضیح"
                      value={hospital_description}
                      onChange={(e) =>
                        this.setState({ hospital_description: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        )}
        {currentEvent === 1 && (
          <div className="row mb-3">
            {hospital.name ? (
              <div className="col-lg-12 col-md-12 m-auto">
                <div className="row mt-1 mb-2">
                  <div className="col-lg-12">
                    <NotifCard text1="کاربر گرامی لطفا تلفن های (خط شهری - یا موبایل) سازمان را وارد کنید" />
                  </div>
                </div>
                <div
                  className=" text-right w-100 position-relative"
                  style={{
                    padding: "0 20px ",
                    color: "#535353",
                    fontSize: "15px",
                  }}
                >
                  <p>شماره تماس ها</p>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    {hospital_tels.map((tel, i) => {
                      return (
                        <Input
                          type="number"
                          className="number-input"
                          value={tel}
                          style={{ width: `${100 / hospital_tels.length}%` }}
                          onChange={(e) => handleTels(i, e.target.value)}
                          placeholder="شماره بیمارستان را وارد نمایید"
                        />
                      );
                    })}
                    {hospital_tels.length > 1 ? (
                      <BtnRound
                        style={{ backgroundSize: "34px" }}
                        className={`cancel-icon`}
                        onClick={() =>
                          this.setState({
                            hospital_tels: hospital_tels.slice(0, -1),
                          })
                        }
                      />
                    ) : (
                      ""
                    )}
                    {hospital_tels.length < 6 ? (
                      <BtnRound
                        style={{ backgroundSize: "34px" }}
                        className={`add-icon`}
                        onClick={() =>
                          this.setState({
                            hospital_tels: [...hospital_tels, ""],
                          })
                        }
                      />
                    ) : (
                      ""
                    )}
                    <BtnRound
                      style={{ backgroundSize: "34px" }}
                      className={`save-icon`}
                      onClick={putPhones}
                    />
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        )}
        {currentEvent === 2 && (
          <div
            className="row align-items-center justify-content-center"
            style={{ marginTop: "90px" }}
          >
            <div className="col-lg-5">
              <List
                title="interval"
                onAction={() => {
                  if (internalLinks.length === 5) {
                    return userActions.failure(
                      "توجه شما مجاز به افزودن 5 لینک داخلی هستید"
                    );
                  }
                  this.setState({ addLinksModal: true, link_type: "interval" });
                }}
              >
                <Banner title="داخلی" />
                {isLoading ? (
                  <Loading />
                ) : internalLinks.length ? (
                  internalLinks.map((link, i) => (
                    <ListItem
                      i={i}
                      key={i + 1}
                      link={link}
                      dispatch={dispatch}
                      onDelete={() => handleDelete(link.id)}
                    />
                  ))
                ) : (
                  <EmptyListItem />
                )}
              </List>
            </div>
            <div className="col-lg-5">
              <List
                title="external"
                onAction={() => {
                  if (externalLinks.length === 5) {
                    return userActions.failure(
                      "توجه شما مجاز به افزودن 5 لینک خارجی هستید"
                    );
                  }
                  this.setState({ addLinksModal: true, link_type: "external" });
                }}
              >
                <Banner title="خارجی" />
                {isLoading ? (
                  <Loading />
                ) : externalLinks.length ? (
                  externalLinks.map((link, i) => (
                    <ListItem
                      i={i}
                      key={i + 1}
                      link={link}
                      dispatch={dispatch}
                      onDelete={() => handleDelete(link.id)}
                    />
                  ))
                ) : (
                  <EmptyListItem />
                )}
              </List>
            </div>
            <Modal
              isOpen={addLinksModal}
              contentLabel="Monitor Modal"
              portalClassName="full_screen_modal"
            >
              <ModalPartners
                name={name}
                link={link}
                dispatch={dispatch}
                onClose={reset}
                onPost={postLinks}
                onName={(e) =>
                  this.setState({
                    name: e.target.value,
                  })
                }
                onUrl={(e) =>
                  this.setState({
                    link: e.target.value,
                  })
                }
              />
            </Modal>
          </div>
        )}
      </div>
    );
  }
}

class ModalPartners extends Component {
  componentDidMount = () => {
    document.querySelector(".logout-btn").classList.add("hidden");
    document.querySelector(".logout-btn-bg").classList.add("hidden");
  };

  componentWillUnmount = () => {
    document.querySelector(".logout-btn").classList.remove("hidden");
    document.querySelector(".logout-btn-bg").classList.remove("hidden");
  };

  render() {
    const { name, link, onClose, onPost, onName, onUrl } = this.props;

    return (
      <div className="modal--add-link general_container">
        <div className="row col-lg-12 col-md-12 banner">
          <p>افزودن لینک فوتر</p>
          <button onClick={onClose}>&#10005;</button>
        </div>
        <div className="mt-4 w-100 px-4">
          <p className="text-right px-3 text_style">نام لینک</p>
          <Input
            value={name}
            className="mb-3"
            onChange={onName}
            placeholder="نام لینک را انتخاب کنید"
          />
        </div>
        <div className="w-100 px-4 url_style">
          <p className="text-right text_style px-3 mt-0 mb-2 d-flex">URL</p>
          <Input
            value={link}
            className="number-input mt-2"
            onChange={onUrl}
            placeholder="URL را انتخاب کنید"
          />
        </div>
        <div className="row col-lg-12 footer">
          <button
            onClick={() => {
              if (name.length === 0) {
                return userActions.failure("لطفا نام لینک را انتخاب کنید");
              } else if (link.length === 0) {
                return userActions.failure("لطفا URL را انتخاب کنید");
              }
              onPost();
            }}
          >
            ثبت
          </button>
          <button className="ghost" onClick={onClose}>
            بازگشت
          </button>
        </div>
      </div>
    );
  }
}

class Navigation extends Component {
  render() {
    const { onClick, BtnList } = this.props;
    return (
      <div className="col-lg-12">
        <div className="border-0 h-100 ">
          <RoundedBtnWrapper>
            {BtnList.map(({ img, text }, i) => (
              <RoundedBtn
                key={i}
                img={img}
                text={text}
                onClick={() => onClick(i)}
              />
            ))}
          </RoundedBtnWrapper>
        </div>
      </div>
    );
  }
}

class RoundedBtnWrapper extends Component {
  render() {
    return (
      <div
        className="card border-0"
        style={{ borderRadius: "20px", background: "transparent" }}
      >
        <div className="card-body" style={{ height: "200px" }}>
          <div className="d-flex flex-wrap justify-content-center">
            <div className="card-deck">{this.props.children}</div>
          </div>
        </div>
      </div>
    );
  }
}

class RoundedBtn extends Component {
  render() {
    const { img, text, onClick } = this.props;
    if (text === "تلفن ها") {
      return (
        <div
          className="card text-center border-0 "
          style={{ borderRadius: "20px", background: "transparent" }}
        >
          <div
            className="card-body border-0 d-flex"
            style={{ padding: "1.25rem 0" }}
          >
            <a
              className="d-flex flex-column align-items-center indexs btn"
              style={{ padding: "0px 0.75rem 0.375rem 0.75rem" }}
              onClick={onClick}
            >
              <img src={img} alt="" width="90" height="90" />
              <span
                className="iran-sans_Bold text-center text-dark my-2"
                style={{
                  width: "100px",
                  fontSize: "12px",
                }}
              >
                {text}
              </span>
            </a>
          </div>
        </div>
      );
    }

    return (
      <div
        className="card text-center border-0 "
        style={{ borderRadius: "20px", background: "transparent" }}
      >
        <div
          className="card-body border-0 d-flex"
          style={{ padding: "1.25rem 0" }}
        >
          <a
            className="d-flex flex-column align-items-center indexs btn"
            onClick={onClick}
          >
            <img src={img} alt="" width="75" height="75" />
            <span
              className="iran-sans_Bold text-center text-dark my-2"
              style={{
                width: "100px",
                fontSize: "12px",
                paddingTop: "10px",
              }}
            >
              {text}
            </span>
          </a>
        </div>
      </div>
    );
  }
}

class EmptyListItem extends Component {
  render() {
    return (
      <li className="generalInfo__list__item empty-list">
        <p className="generalInfo__list__item__text empty-list__child">
          برای نمایش اطلاعات از دکمه های بالا استفاده نمایید
        </p>
      </li>
    );
  }
}

class List extends Component {
  render() {
    const { onAction, title } = this.props;

    return (
      <div className="list-wrapper">
        <button className="glowing-btn">
          {title === "interval" ? (
            <span className="glowing-txt">
              دا<span className="faulty-letter">خ</span>لی
            </span>
          ) : (
            <span className="glowing-txt">
              خا<span className="faulty-letter">ر</span>جی
            </span>
          )}
        </button>
        <ul className="generalInfo__list">{this.props.children}</ul>
        <div className="row d-flex justify-content-center align-items-center">
          <button
            class="btn mx-auto btn-primary mt-3 rounded-pill iran-sans_Bold px-5"
            onClick={onAction}
          >
            افزودن
          </button>
        </div>
      </div>
    );
  }
}

class Banner extends Component {
  render() {
    return (
      <li className="generalInfo__list__banner" key="0">
        <div className="generalInfo__list__banner__child">ردیف</div>
        <div className="generalInfo__list__banner__child">نام</div>
        <div className="generalInfo__list__banner__child">
          لینک {this.props.title}
        </div>
        <div className="generalInfo__list__banner__child">عملیـات</div>
      </li>
    );
  }
}

class ListItem extends Component {
  render() {
    if (this.props.link === undefined) return null;

    const { i, link, dispatch, onDelete } = this.props;
    const { title, url } = link;

    return (
      <li className={`generalInfo__list__item`}>
        <ListItemBtnContainer>
          <p className="generalInfo__list__item__text">{i + 1}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="generalInfo__list__item__text">{title}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="generalInfo__list__item__text">{url}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <BtnRound className={`delete-icon`} onClick={onDelete} />
        </ListItemBtnContainer>
      </li>
    );
  }
}

class BtnRound extends Component {
  render() {
    return (
      <button
        style={this.props.style}
        className={`btn-round ${this.props.className}`}
        onClick={this.props.onClick}
        data-tip={this.props.data_tip}
      ></button>
    );
  }
}

class ListItemBtnContainer extends Component {
  render() {
    return (
      <div className="generalInfo__list__item__btn-container">
        {this.props.children}
        {/* <ReactTooltip type="dark" /> */}
      </div>
    );
  }
}

class Loading extends Component {
  render() {
    return (
      <li className="generalInfo__list__item empty-list">
        <img src={loadingGif} style={{ width: "160px" }} />
      </li>
    );
  }
}

class Textarea extends Component {
  render() {
    return (
      <textarea
        className={`special-textarea ${this.props.className}`}
        placeholder={`${this.props.placeholder || ""}`}
        value={this.props.value || ""}
        onChange={this.props.onChange}
        style={this.props.style}
      />
    );
  }
}

class Input extends Component {
  render() {
    const { value, onChange, placeholder, style, type, className } = this.props;
    return (
      <input
        name="name"
        type={type ? type : "text"}
        className={`form-control ${className}`}
        aria-label="Full Name"
        style={style}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
      />
    );
  }
}

class NotifCard extends Component {
  render() {
    const { text1, text2, color1 = "#777777", color2 = "#6c00ff" } = this.props;

    return (
      <p className="notif py-3 px-5">
        <p style={{ color: color1, margin: 0 }}>{text1}</p>
        {text2 && (
          <p style={{ color: color2, margin: "10px 0 0 0" }}>{text2}</p>
        )}
      </p>
    );
  }
}

const GeneralInfo = connect((state) => ({
  globalStorage: state.globalStorage,
}))(GeneralInfo_);

export { GeneralInfo };
